import navMenuItems from '@/navigation/default.supervizr'
import navMenuItemsTransurbSupervizr from '@/navigation/transurb.supervizr'
import navMenuItemsLocalSupervizr from '@/navigation/local.supervizr'
import navMenuItemsSgsSupervizr from '@/navigation/sgs.supervizr'
import navMenuItemsSgsHypervizr from '@/navigation/sgs.hypervizr'
import navMenuItemsGtechSupervizr from '@/navigation/gtech.supervizr'
import navMenuItemsSuperAdminSupervizr from '@/navigation/superadmin.supervizr'
import { capitalizeFirstLetter } from '@/libs/formatting'
import router from '@/router'

function getSubDomain() {
  let host = window.location.hostname
  host = host.replace('http://', '').replace('https://', '')
  const parts = host.split('.')
  let sub = ""
  if (parts.length > 2) {
    sub = parts[0]
  }
  return sub
}

function getDomain() {
  const host = window.location.hostname
  const parts = host.split('.')
  let result = host
  if (parts.length > 1) {
    result = parts.slice(parts.length - 2).join('.')
  } else {
    result = host
  }
  return result
}

function getProtocol() {
  return window.location.protocol
}

function getPort() {
  return window.location.port
}

function getBaseUrl() {
  let subDomain = getSubDomain()
  let domain = getDomain()
  let protocol = getProtocol()
  let port = getPort()
  let baseUrl = `${protocol}//api.${domain}${port ? ':' + port : ''}`
  return baseUrl
}

function getBaseApiUrl() {
  let subDomain = getSubDomain()
  let domain = getDomain()
  let protocol = getProtocol()
  let port = getPort()
  domain = "supervizr.net"
  let baseUrl = `${protocol}//api.${domain}${port ? ':' + port : ''}/${subDomain}`
  return baseUrl
}

function getBaseAssetUrl() {
  let subDomain = getSubDomain()
  let domain = getDomain()
  let protocol = getProtocol()
  let port = getPort()
  domain = "supervizr.net"
  let baseUrl = `${protocol}//api.${domain}${port ? ':' + port : ''}`
  return baseUrl
}

function getBaseApiUrlLocal() {
  let subDomain = getSubDomain()
  let baseUrl = `http://api.supervizr.net:9001/${subDomain}`
  return baseUrl
}

// Fonction pour filtrer récursivement les enfants et les éléments principaux
function filterMenuItems(items, userPermissions) {
  return items.reduce((filtered, item) => {
    // Filtrage des enfants
    const filteredChildren = item.submenu ? filterMenuItems(item.submenu, userPermissions) : []
    
    // Déterminer si l'élément principal doit être inclus
    const isVisible = userPermissions.includes(item.permission) || filteredChildren.length > 0
    
    if (isVisible) {
      const filteredItem = { ...item }
      
      // Si des sous-menus sont présents et filtrés, les assigner
      if (filteredChildren.length > 0) {
        filteredItem.submenu = filteredChildren
        // Vérifier si l'un des sous-menus est actif
        const hasActiveChild = filteredChildren.some(child => child.active)
        if (hasActiveChild) {
          filteredItem.active = true
        }
      }

      // Appliquer le formatage des titres
      if (filteredItem.text) {
        filteredItem.text = capitalizeFirstLetter(filteredItem.text)
      }
      if (filteredItem.header) {
        filteredItem.header = capitalizeFirstLetter(filteredItem.header)
      }
      
      if (filteredItem.route) {
        try {
          let routeInfo = router.resolve({ name: filteredItem.route })
          filteredItem.link = routeInfo.href || routeInfo.route.path
          const currentPath = window.location.pathname

          if (currentPath === filteredItem.link) {
            filteredItem.active = true
          } else {
            filteredItem.active = filteredItem.active || false
          }
        } catch (e) {
          filteredItem.active = filteredItem.active || false
        }
      } else {
        filteredItem.active = filteredItem.active || false
      }

      if (filteredItem.submenu) {
        filteredItem.submenu = filteredItem.submenu.map(child => ({
          ...child,
          title: child.text ? capitalizeFirstLetter(child.text) : undefined
        }))
      }
      filtered.push(filteredItem)
    }

    return filtered
  }, [])
}

function importNavMenuItemsByDomain() {
  let url = `${getSubDomain()}.${getDomain()}`
  let menuItems = {
    'default': navMenuItems,
    'transurb.supervizr.net': navMenuItemsTransurbSupervizr,
    'local.supervizr.net': navMenuItemsLocalSupervizr,
    'sgs.supervizr.net': navMenuItemsSgsSupervizr,
    'sgs.hypervizr.net': navMenuItemsSgsHypervizr,
    'gtech.supervizr.net': navMenuItemsGtechSupervizr,
    'superadmin.supervizr.net': navMenuItemsSuperAdminSupervizr,
  }
  
  let menuItem = menuItems.default
  if (Object.keys(menuItems).includes(url)) {
    menuItem = menuItems[url]
  }

  return menuItem
}

// Fonction utilitaire pour émettre des événements
const dispatchGlobalEvents = (vm, user) => {
  // Émettre un événement global pour synchroniser axios
  if (window && window.dispatchEvent) {
    if (user) {
      window.dispatchEvent(new CustomEvent('user-token-changed', {
        detail: { token: user.token }
      }))
    } else {
      window.dispatchEvent(new CustomEvent('user-logged-out'))
    }
  }
  
  // Émettre un événement Vue
  if (vm && vm.$root) {
    if (user) {
      vm.$root.$emit('user-token-changed', user.token)
    } else {
      vm.$root.$emit('user-logged-out')
    }
  }
}

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    subDomain: getSubDomain(),
    domain: getDomain(),
    protocol: getProtocol(),
    port: getPort(),
    baseUrl: getBaseUrl(),
    baseAssetUrl: getBaseAssetUrl(),
    baseApiUrl: getBaseApiUrl(),
    baseApiUrlLocal: getBaseApiUrlLocal(),
    user: null,
    menuItems: importNavMenuItemsByDomain()
  },
  getters: {
    subDomain: state => state.subDomain,
    domain: state => state.domain,
    protocol: state => state.protocol,
    baseUrl: state => state.baseUrl,
    baseAssetUrl: state => state.baseAssetUrl,
    baseApiUrl: state => state.baseApiUrl,
    baseApiUrlLocal: state => state.baseApiUrlLocal,
    userId: state => state.user ? state.user.id : null,
    userFirstName: state => state.user ? state.user.firstName : '',
    userLastName: state => state.user ? state.user.lastName : '',
    userEmail: state => state.user ? state.user.email : '',
    userToken: state => {
      return state.user && state.user.token ? state.user.token : ''
    },
    userPermissions: state => state.user ? state.user.permissions : [],
    menuItems: state => state.menuItems,
    filteredMenuItems: (state, getters) => {
      return filterMenuItems(state.menuItems, getters.userPermissions)
    },
    userInfo: state => state.user,
    isLoggedIn: state => !!state.user && !!state.user.token
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_USER(state, user) {
      state.user = user
      console.log('Mutation SET_USER appelée avec:', user ? user.email : 'null')
    },
    CLEAR_USER(state) {
      state.user = null
      console.log('Mutation CLEAR_USER appelée')
    },
    UPDATE_USER_TOKEN(state, token) {
      if (state.user) {
        state.user.token = token
        console.log('Mutation UPDATE_USER_TOKEN appelée avec nouveau token')
      }
    },
    UPDATE_MENU_ITEMS(state, menuItems) {
      state.menuItems = menuItems
    }
  },
  actions: {
    // ACTION PRINCIPALE - DOIT ÊTRE APPELÉE PAR LE LOGIN
    setUser({ commit, rootState }, user) {
      return new Promise((resolve) => {
        console.log('Action setUser appelée avec:', user.email)
        
        // 1. S'assurer que l'objet utilisateur est complet
        const userObject = {
          id: user.id,
          firstName: user.firstName || user.email.split('@')[0],
          lastName: user.lastName || 'Utilisateur',
          email: user.email,
          token: user.token,
          user_photo:user.user_photo,
          permissions: user.permissions || []
        }
        
        // 2. Commit la mutation
        commit('SET_USER', userObject)
        
        // 3. Émettre des événements pour synchroniser axios
        dispatchGlobalEvents(this._vm, userObject)
        
        resolve(userObject)
      })
    },

    // ACTION POUR DÉCONNEXION
    logout({ commit }) {
  return new Promise((resolve) => {
    console.log('Action logout appelée')

    commit('CLEAR_USER')
    dispatchGlobalEvents(this._vm, null)

    // ❌ SUPPRIMÉ: plus de router ici

    resolve()
  })
},

    // ACTION POUR NETTOYER (avant nouvelle connexion)
    clearUser({ commit }) {
      return new Promise((resolve) => {
        console.log('Action clearUser appelée')
        
        // 1. Commit la mutation
        commit('CLEAR_USER')
        
        // 2. Émettre des événements pour synchroniser axios
        dispatchGlobalEvents(this._vm, null)
        
        resolve()
      })
    },

    // ACTION POUR RAFRAÎCHIR LE TOKEN
    refreshToken({ commit }, newToken) {
      console.log('Action refreshToken appelée avec nouveau token')
      commit('UPDATE_USER_TOKEN', newToken)
      dispatchGlobalEvents(this._vm, { token: newToken })
    },

    updateMenuItems({ commit }, menuItems) {
      commit('UPDATE_MENU_ITEMS', menuItems)
    }
  }
}